import { EmployeeAdditionalIncome } from '@app/models/payroll/employee-additional-income.model';
import { ModelMixin } from '@models/core/base-generic.model';
import { T4Box } from './t4-box.model';
import { Rl1Box } from './rl1-box.model';

export class CompanyAdditionalIncome extends ModelMixin<CompanyAdditionalIncome>() {
    protected static _resource = 'payroll/companies/:company/additionalIncomes';

    protected static _version = 'v2';

    protected static _serializeAttributes = ['description', 'active'];

    get description(): string {
        return this._attributes['description'] || ''; // Null descriptions should be returned as an empty string
    }

    set description(value: string) {
        this._attributes['description'] = value || null; // Empty descriptions should be saved as null
    }

    get active(): boolean {
        return this._attributes['active'];
    }

    set active(value: boolean) {
        this._attributes['active'] = value;
    }

    get name(): string {
        return this._attributes['name'];
    }

    get displayName(): string {
        return this._attributes['displayName'];
    }

    get periodic(): boolean {
        return this._attributes['periodic'];
    }

    get taxable(): boolean {
        return this._attributes['taxable'];
    }

    get eptable(): boolean {
        return this._attributes['eptable'];
    }

    get assessable(): boolean {
        return this._attributes['assessable'];
    }

    get pensionable(): boolean {
        return this._attributes['pensionable'];
    }

    get insurable(): boolean {
        return this._attributes['insurable'];
    }

    get vacationable(): boolean {
        return this._attributes['vacationable'];
    }

    get custom(): boolean {
        return this._attributes['custom'];
    }

    get required(): boolean {
        return this._attributes['required'];
    }

    get employeeAdditionalIncomes(): EmployeeAdditionalIncome[] {
        return this.hasMany(EmployeeAdditionalIncome, 'employeeAdditionalIncomes');
    }

    set employeeAdditionalIncomes(employeeAdditionalIncomes: EmployeeAdditionalIncome[]) {
        this.setMany('employeeAdditionalIncomes', employeeAdditionalIncomes);
    }

    get t4Boxes(): T4Box[] {
        return this.hasMany(T4Box, 't4Boxes');
    }

    get rl1Boxes(): Rl1Box[] {
        return this.hasMany(Rl1Box, 'rl1Boxes');
    }

    get recurrable(): boolean {
        return this._attributes['recurrable'];
    }

    get multiplier(): number {
        return this._attributes['multiplier'];
    }

    get hasHours(): boolean {
        return this._attributes['hasHours'];
    }

    get subtractFromSalary(): boolean {
        return this._attributes['subtractFromSalary'];
    }

    get reduceVacationPayBalance(): boolean {
        return this._attributes['reduceVacationPayBalance'];
    }

    get timeTrackingEmployeeHoursExists(): boolean {
        return this._attributes['timeTrackingEmployeeHoursExists'];
    }

    get timeOffEmployeeHoursExist(): boolean {
        return this._attributes['timeOffEmployeeHoursExists'];
    }
}
